remainingPages = require 'utils/remaining-pages'
Registrable = require 'mixins/registrable'

App.StickyHeaderTableComponent = Em.Component.extend Registrable,
  tagName: 'table'

  onScrollBinded: (-> @onScroll.bind(@) ).property()

  scrollableSelector: '.table-container'
  tableHeadSelector: 'thead th'

  loadMoreFactor: 0.3

  onScroll: ->
    $el = @getScrollableElem()

    return unless $el

    offset = $el.scrollTop()

    @$( @get('tableHeadSelector') ).css({
      position: 'relative',
      top: "#{offset}px" })

    if remainingPages( $el.get(0) ) < @get('loadMoreFactor')
      @sendAction('onLoadMore')

  getScrollableElem: ->
    @$()?.closest( @get('scrollableSelector') )

  installScrollHandler: (->
    $el = @getScrollableElem()
    $el?.on('scroll', @get('onScrollBinded'))
    do @onScroll
  ).on('didInsertElement')

  uninstallScrollHandler: (->
    $el = @getScrollableElem()
    $el?.off('scroll', @get('onScrollBinded'))
  ).on('willDestroyElement')